import useSWR, { SWRResponse } from 'swr';
import { getNextColdLeadContactsCount, getNextLeadContactsCount } from '../../../providers/api/call-center/callCenterLeadProvider';
import { CallContextType, Count } from '../../../providers/api/dtos';
import { API_CALL_CENTER, API_CALL_CENTER_SERVICE, API_FEEDBACKS_PATH } from '../../../providers/api/api';
import { getFeedbackContactsCount } from '../../../providers/api/call-center/callCenterFeedbackProvider';

export const NEXT_CALLCENTER_CONTACTS_COUNT_RID = `${API_CALL_CENTER}/call-center/next-contact/count`;
export const FEEDBACKS_COUNT_RID = `${API_FEEDBACKS_PATH}/next-contact/count`;
export const NEXT_CALLCENTER_COLD_LEAD_CONTACTS_COUNT_RID = `${API_CALL_CENTER_SERVICE}/call-center/next-contact/count`;

export function useContactToProcessCount(type: CallContextType): SWRResponse<Count, Error> {
  let callParams: { type?: string, provider: () => Promise<Count> } = { type: undefined, provider: () => Promise.resolve({ count: 0 }) };

  switch (type) {
    case CallContextType.LEAD: {
      callParams = { type: NEXT_CALLCENTER_CONTACTS_COUNT_RID, provider: getNextLeadContactsCount };
      break;
    }
    case CallContextType.COLD_LEAD: {
      callParams = { type: NEXT_CALLCENTER_COLD_LEAD_CONTACTS_COUNT_RID, provider: getNextColdLeadContactsCount };
      break;
    }
    case CallContextType.SURVEY: {
      callParams = { type: FEEDBACKS_COUNT_RID, provider: getFeedbackContactsCount };
      break;
    }
    default: { callParams = { type: undefined, provider: () => Promise.resolve({ count: 0 }) }; }
  }

  return useSWR([callParams.type], callParams.provider);
}
